import { Mail, MessageSquare, FileText, BookOpen, Shield, ChevronRight } from 'lucide-react';
import { Link } from "react-router-dom";
import logo from '../../Assets/Images/logo.svg';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-logo">
            <img src={logo} alt="Горизонт Сатурна" className="footer-logo-img" />
            <p className="footer-org-name">
              АНО «Центр Цифровой Трансформации «Горизонт Сатурна» РС(Я)
            </p>
            <p className="footer-copyright">© 2022-2025 Все права защищены</p>
          </div>

          <div className="footer-col">
            <h3 className="footer-title">
              <MessageSquare className="footer-icon" /> Контакты
            </h3>
            <ul className="footer-links">
              <li>
                <a href="mailto:saturn.skyline.offical@gmail.com" className="footer-link">
                  <Mail size={16} className="link-icon" />
                  saturn.skyline.offical@gmail.com
                </a>
              </li>
              <li>
                <a href="https://wa.me/+79963170873" className="footer-link">
                  <MessageSquare size={16} className="link-icon" />
                  WhatsApp: +7 (996) 317-08-73
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h3 className="footer-title">
              <FileText className="footer-icon" /> Документация
            </h3>
            <ul className="footer-links">
              <li>
                <Link to="/Regulation" className="footer-link">
                  <ChevronRight size={16} className="link-icon" />
                  Положение о конкурсе
                </Link>
              </li>
              <li>
                <Link to="/Docs" className="footer-link">
                  <ChevronRight size={16} className="link-icon" />
                  Документы
                </Link>
              </li>
              <li>
                <Link to="/AssetsBook" className="footer-link">
                  <ChevronRight size={16} className="link-icon" />
                  БрендБук
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h3 className="footer-title">
              <Shield className="footer-icon" /> Согласия
            </h3>
            <ul className="footer-links">
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://docs.google.com/document/d/16Oik64h-jvqFvQq-N3ZoO5AjPeWJuzk6r5iTZBZhD3w/edit?usp=sharing"
                  className="footer-link"
                >
                  <ChevronRight size={16} className="link-icon" />
                  Согласие (очная смена)
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://docs.google.com/document/d/1M2VNHHlpfvtnrBEJEDsqUkin2kW5BVJrIa7qtg7rxCs/edit?usp=sharing"
                  className="footer-link"
                >
                  <ChevronRight size={16} className="link-icon" />
                  Согласие родителя
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <p className="footer-copyright-mobile">
            © 2022-2025 АНО ЦЦТ «Горизонт Сатурна» РС(Я). Все права защищены.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;